import React, { Fragment, useState ,useEffect} from 'react';
import { Container, Row, Col } from 'reactstrap';
import { TabMenu } from 'primereact/tabmenu';
import { IndexBrands } from './IndexBrands';
import { IndexInfoAnalytes } from './IndexInfoAnalytes';
import { IndexAppCodes } from './IndexAppCodes';
import { IndexMethods } from './IndexMethods';
import { IndexCharacteristic } from './IndexCharacteristic';
import '../analytes/TabmenuStyle.css'

export const IndexAnalytes = (props) => {
      const [activeIndex, setActiveIndex] = useState(() => {
        const savedIndex = localStorage.getItem('activeIndex');
        return savedIndex ? parseInt(savedIndex, 10) : 0; 
    });
     useEffect(() => {
        localStorage.setItem('activeIndex', activeIndex);
    }, [activeIndex]);

    const items = [
        { label: 'Marcas', icon: 'fa fa-cog' },
        { label: 'Métodos', icon: 'fa fa-flask' },
        { label: 'Analitos', icon: 'fa fa-building-o' },
        { label: 'Características', icon: 'fa fa-star' },
        { label: 'Vinculación de analitos', icon: 'fa fa-link' },
    ];

      const handleTabChange = (e) => {
        setActiveIndex(e.index); 
        localStorage.setItem('activeIndex', e.index); 
        // window.location.reload(); 
    };

    return (
        <Fragment>
            <div className='container-global-zoom'  >
                <Row>
                    <Col md="12">
                        <TabMenu
                            model={items}
                            activeIndex={activeIndex}
                            onTabChange={handleTabChange}
                            className="custom-tabmenu full-width"
                        />

                        <div style={{ marginTop: '1rem' }}>
                            {activeIndex === 0 && <IndexBrands {...props} />}
                            {activeIndex === 1 && <IndexMethods {...props} />}
                            {activeIndex === 2 && <IndexInfoAnalytes {...props} />}
                            {activeIndex === 3 && <IndexCharacteristic {...props} />}
                            {activeIndex === 4 && <IndexAppCodes {...props} />}
                        </div>

                    </Col>
                </Row>
            </div>
        </Fragment>
    );
};
